export enum SquareModelFigureStatus {
    EMPTY,
    FULL,
    HALF
}